// removed by extract-text-webpack-plugin
module.exports = {"nf-view-users":"nf-view-users","nf-view-users__content":"nf-view-users__content","nf-view-users__grid":"nf-view-users__grid"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/SuperAdminHome/SearchUsers/SearchUsers.scss
// module id = 5549
// module chunks = 1